import { useMutation } from '@tanstack/react-query';
import axiosClient from 'api/config/axios';
import { createErrorHandler } from 'api/config/axios.errors';
import { adaptDispute } from 'api/escrow/adapters';

type Params = {
  disputeId: string;
};

async function acceptTriageResolution(params: Params) {
  const result = await axiosClient.mutate.post(`/api/v1/escrow/cases/${params.disputeId}/accept-triage-resolution`);
  return adaptDispute(result.data.dispute);
}

const mutationKey = ['escrow', 'accept-triage-resolution'] as const;

export function useAcceptTriageResolutionMutation() {
  return useMutation({
    mutationKey,
    mutationFn: acceptTriageResolution,
    onError: createErrorHandler('Unable to accept the resolution at this time.'),
  });
}
